import dayjs from 'dayjs';
import { IAttachment } from './types';
import { getAttachmentType } from '../utils/attachment-type';

export enum ModalType {
  MOVE = 'move',
  CLONE = 'clone',
  TRASH = 'trash',
  RESEND = 'resend',
  DELETE = 'delete',
  ADD_RECORD = 'add record',
  ADD_TO_EVENT = 'add to event',
  SEARCH = 'search',
  CREATE_APPROVAL = 'create approval',
  EMAIL_EXTERNAL = 'email external',
  ADD_FORM = 'add form',
  SEND_SMS = 'send sms',
  SEND_FORM = 'send form',
  SEND_EMAIL = 'send email',
  INVITE_TO_TIMESLOT = 'invite to timeslot',
  ADD_EDIT_TASK = 'add edit task',
  TASK_WORKFLOW = 'task workflow',
  EXPORT_TO_ONBOARD = 'export to onboard',
  ONBOARD_EXPRESS = 'onboard express',
  XREF = 'xref',
  UNUSUAL_ACTIVITY = 'unusual activity',
  COGNOLOGY = 'cognology',
  EDIT_COGNOLOGY = 'edit cognology',
  COGNOLOGY_WAITING_FOR_APPROVAL = 'cognology waiting for approval',
  COGNOLOGY_APPROVED = 'cognology approved',
  MVS = 'mvs',
  REFEROO = 'referoo',
  FOUNDU = 'foundu',
  TESTGRID = 'testgrid',
  HRONBOARD = 'hronboard',
  ROUBLER = 'roubler',
  SPARKHIRE = 'sparkhire',
  FIT2WORK = 'fit2work',
  ALAYACARE = 'alayacare',
  ELMO = 'elmo',
  INTELLIHR = 'intellihr',
  RECRUITMENT_HELP = 'recruitment help',
  EXPORT_TO_CSV = 'export to csv',
  PREEMPLOYMENT_CHECK = 'pre-employment check'
}

export const cognologyExportPreference = [
  {
    label: 'Quick',
    value: 'quick'
  },
  {
    label: 'Full',
    value: 'full'
  }
];

export enum SectionName {
  CandidateTags = 'Candidate Tags',
  FelixAISummary = 'Felix AI Summary',
  Responses = 'Responses',
  Notepad = 'Notepad',
  Actions = 'Actions',
  ApplicationQuestionnaire = 'Application questionnaire',
  Attachments = 'Attachments'
}

export enum AttachmentType {
  Image = 'image',
  Video = 'video',
  Audio = 'audio',
  Text = 'text',
  Pdf = 'pdf',
  Word = 'word'
}

export const defaultSections = [
  'Candidate Tags',
  'Felix AI Summary',
  'Responses',
  'Notepad',
  'Actions',
  'Attachments',
  'Application questionnaire'
];

export const getApplicationRatingColor = (rating: number | null) => {
  if (rating === null) return { color: '#666666', background: '#E5E5E5' };
  if (rating <= 34) {
    return { color: 'rgba(227,125,122)', background: 'rgba(227,125,122,0.12)' };
  } else if (rating <= 49) {
    return { color: 'rgba(229,153,92)', background: 'rgba(229,153,92,0.12)' };
  } else if (rating <= 74) {
    return { color: 'rgba(254,213,0)', background: 'rgba(254,213,0,0.12)' };
  } else if (rating <= 90) {
    return { color: 'rgba(140,207,149)', background: 'rgba(140,207,149,0.12)' };
  } else if (rating <= 100) {
    return { color: 'rgba(62,170,62)', background: 'rgba(62,170,62,0.12)' };
  }
};

export const timeStringToSeconds = (time: string) => {
  const [hour, minute, second] = time.split(':').map((t) => parseInt(t));
  return dayjs.duration({ hours: hour, minutes: minute, seconds: second }).asSeconds();
};

export const secondsToTimeString = (seconds: number) => {
  return dayjs.duration(seconds, 'seconds').format('HH:mm:ss');
};

export const checkMissingPlaceholders = (placeholders: string[], body: string) => {
  const missingPlaceholders = placeholders.filter((placeholder) => !body.includes(placeholder));
  return !!missingPlaceholders.length;
};

export const InitialTimeStampState = {
  hasTyped: false,
  timestampError: { nameMessage: '', valueMessage: '', id: null }
};

export const categorizeAttachments = (attachments: IAttachment[]) => {
  return attachments.reduce(
    (acc: { videos: IAttachment[]; files: IAttachment[] }, attachment: IAttachment) => {
      const selectedAttachment = getAttachmentType(attachment);
      if (selectedAttachment === AttachmentType.Video) {
        acc.videos.push(attachment);
      } else {
        acc.files.push(attachment);
      }
      return acc;
    },
    { files: [], videos: [] }
  );
};

export const VIDEO_INTERVIEW_SOURCE_INDEX = 1;
export const VIDEO_INTERVIEW_DISPLAY_NAME = 'Video Interview';

export const LINKEDIN_URL_REGEX =
  /^(https:\/\/)(|www\.|[a-z]{2}\.)?linkedin.com\/in\/([a-zA-Z0-9-]*)/gm;

export const ADD_FORM_PLACEHOLDER = '{FORM}';
export const INVITE_TO_TIMESLOT_PLACEHOLDER = '{INTERVIEW_URL}';
